<template>
  <div>
<b-row>
      <b-col sm="2">
        <b-input size="sm" v-model="memberFilter" placeholder="会員番号"/>
      </b-col>
      <b-col sm="2">
        <b-input size="sm" v-model="asinFilter" placeholder="ASIN"/>
      </b-col>
      <b-col sm="2">
        <b-input size="sm" v-model="skuFilter" placeholder="SKU"/>
      </b-col>
      <b-col md="3">
        <b-button @click="getInfomation()" size="md" variant="danger">　情報取得　</b-button>
      </b-col>
      <b-col md="3">
        <b-button @click="updateSkuInfo()" size="md" variant="danger">　　　　　　　更新　　　　　　　</b-button>
      </b-col>
    </b-row>
    <b-row>
      <h5>Amazon商品情報</h5>
    </b-row>
    <b-row>
      <b-col md="12">
        <b-table show-empty stacked="md" bordered=true striped=true small=true hover=true
                :items="amazonInfoItems" :fields="amazonInfoFields"
                :current-page="currentPage" :per-page="perPage"
                :sort-by.sync="sortBy" :sort-desc.sync="sortDesc" :sort-direction="sortDirection">
          <template slot="refBtn" slot-scope="row">
            <b-button size="sm" @click="refSku(row.item)" variant="danger">　　選択　　</b-button>
          </template>
        </b-table>
      </b-col>
    </b-row>
    <b-row>
      <h5>入庫情報</h5>
    </b-row>
    <b-row>
      <b-col md="12">
        <b-table show-empty stacked="md" bordered=true striped=true small=true hover=true
                :items="inboundItems" :fields="inboundFields"
                :current-page="currentPage" :per-page="perPage"
                :sort-by.sync="sortBy" :sort-desc.sync="sortDesc" :sort-direction="sortDirection">
        </b-table>
      </b-col>
    </b-row>
    <b-row>
      <h5>注文情報</h5>
    </b-row>
    <b-row>
      <b-col md="12">
        <b-table show-empty stacked="md" bordered=true striped=true small=true hover=true
                :items="orderItems" :fields="orderFields"
                :current-page="currentPage" :per-page="perPage"
                :sort-by.sync="sortBy" :sort-desc.sync="sortDesc" :sort-direction="sortDirection">
        </b-table>
      </b-col>
    </b-row>
  </div>
</template>

<script>
import Vue from 'vue';
import BaseComponent from '@/components/BaseComponent';
import * as api from '@/api';
import * as utility from '@/utility';

export default {
  mixins: [BaseComponent],
  data() {
    return {
      orderItems: [],
      inboundItems: [],
      amazonInfoItems: [],
      memberFilter: '',
      asinFilter: '',
      skuFilter: '',
      amazonInfoFields: [
        { key: 'memberId',    label: '会員番号', sortable: true, variant: 'base', class: 'table-lw10' },
        { key: 'memberName',     label: '氏名', sortable: true, variant: 'base', class: 'table-lw10' },
        { key: 'asin',     label: 'ASIN', sortable: true, variant: 'base', class: 'table-lw10' },
        { key: 'sku', label: 'SKU', sortable: true, variant: 'base', class: 'table-lw10' },
        { key: 'fnsku',    label: 'FNSKU', sortable: false, variant: 'base', class: 'table-lw10' },
        { key: 'productCondition', label: '状態', sortable: true, variant: 'base', class: 'table-lw10' },
        { key: 'refBtn', label: '選択', sortable: true, variant: 'base', class: 'table-lw10' },
        { key: 'other', label: '備考', sortable: true, variant: 'base'}
      ],
      orderFields: [
        { key: 'memberId',    label: '会員番号', sortable: true, variant: 'base', class: 'table-lw10' },
        { key: 'memberName',     label: '氏名', sortable: true, variant: 'base', class: 'table-lw10' },
        { key: 'asin', label: 'ASIN', sortable: true, variant: 'base', class: 'table-lw10' },
        { key: 'sku',     label: 'SKU', sortable: true, variant: 'base', class: 'table-lw10' },
        { key: 'janCode',    label: 'JANコード', sortable: false, variant: 'base', class: 'table-lw10' },
        { key: 'purchaseQuantity', label: '購入', sortable: true, variant: 'base', class: 'table-lw10' },
        { key: 'other', label: '備考', sortable: true, variant: 'base'}
      ],
      inboundFields: [
        { key: 'memberId',    label: '会員番号', sortable: true, variant: 'base', class: 'table-lw10' },
        { key: 'memberName',     label: '氏名', sortable: true, variant: 'base', class: 'table-lw10' },
        { key: 'asin',     label: 'ASIN', sortable: true, variant: 'base', class: 'table-lw10' },
        { key: 'sku', label: 'SKU', sortable: true, variant: 'base', class: 'table-lw10' },
        { key: 'inboundQuantity', label: '入庫数', sortable: true, variant: 'base', class: 'table-lw10' },
        { key: 'other', label: '備考', sortable: true, variant: 'base'}
      ],
      currentPage: 1,
      perPage: 25,
      totalRows: 0,
      sortBy: null,
      sortDesc: false,
      sortDirection: 'asc',
      amazonAccount: '',
    };
  },
  computed: {
  },
  methods: {
    getInfomation() {
      api.getPappaInfoForSku(this.memberFilter, this.asinFilter, (data) =>{
        this.orderItems = data.orderItems;
        this.inboundItems = data.inboundItems;
        this.amazonInfoItems = data.amazonInfoItems;
        this.addCellVariant(this.amazonInfoItems);
        this.skuFilter = '';
      });
    },
    updateSkuInfo() {
      api.updatePappaInfoForSku(this.memberFilter, this.asinFilter, this.skuFilter, (data) =>{
        this.orderItems = data.orderItems;
        this.inboundItems = data.inboundItems;
        this.amazonInfoItems = data.amazonInfoItems;
        this.addCellVariant(this.amazonInfoItems);
        this.skuFilter = '';
      });
    },
    refSku(item){
      this.skuFilter = item.sku;
    },
    addCellVariant(items) {
      for (const v of items) {
        const errorCells = [];
        if (v['productCondition'] !== null && v['productCondition'] !== 'Unknown') {
          errorCells['memberId'] = 'danger';
          errorCells['memberName'] = 'danger';
          errorCells['asin'] = 'danger';
          errorCells['sku'] = 'danger';
          errorCells['fnsku'] = 'danger';
          errorCells['productCondition'] = 'danger';
          errorCells['refBtn'] = 'danger';
          errorCells['other'] = 'danger';
        }
        v['_cellVariants'] = errorCells;
      }
    },
  },
};

</script>

<style>
.component-margin-top-half {
  margin-top: .5rem;
}
.component-margin-half {
  margin-bottom: .5rem;
}
.component-margin {
  margin-bottom: 1rem;
}
th.table-base {
  background-color: aliceblue!important;
}
th.table-ans {
  background-color: beige!important;
}
.answer-asin-input {
  width: 10rem;
  display: inline-block;
}

@media (min-width: 768px) {
  .table-label { margin-top: 0.3rem; margin-bottom: 0.3rem; }
  .table-linput { transform: translateX(-.3rem); width: calc(100% + 0.6rem); border: 0; text-align: left; }
  .table-rinput { transform: translateX(-.3rem); width: calc(100% + 0.6rem); border: 0; text-align: right; }
  .table-lw1  { min-width:  1rem; max-width:  1rem; width:  1rem; text-align:left; }
  .table-lw2  { min-width:  2rem; max-width:  2rem; width:  2rem; text-align:left; }
  .table-lw3  { min-width:  3rem; max-width:  3rem; width:  3rem; text-align:left; }
  .table-lw4  { min-width:  4rem; max-width:  4rem; width:  4rem; text-align:left; }
  .table-lw5  { min-width:  5rem; max-width:  5rem; width:  5rem; text-align:left; }
  .table-lw6  { min-width:  6rem; max-width:  6rem; width:  6rem; text-align:left; }
  .table-lw7  { min-width:  7rem; max-width:  7rem; width:  7rem; text-align:left; }
  .table-lw8  { min-width:  8rem; max-width:  8rem; width:  8rem; text-align:left; }
  .table-lw9  { min-width:  9rem; max-width:  9rem; width:  9rem; text-align:left; }
  .table-lw10 { min-width: 10rem; max-width: 10rem; width: 10rem; text-align:left; }
  .table-lw11 { min-width: 11rem; max-width: 11rem; width: 11rem; text-align:left; }
  .table-lw12 { min-width: 12rem; max-width: 12rem; width: 12rem; text-align:left; }
  .table-lw13 { min-width: 13rem; max-width: 13rem; width: 13rem; text-align:left; }
  .table-lw14 { min-width: 14rem; max-width: 14rem; width: 14rem; text-align:left; }
  .table-lw15 { min-width: 15rem; max-width: 15rem; width: 15rem; text-align:left; }
  .table-lw16 { min-width: 16rem; max-width: 16rem; width: 16rem; text-align:left; }
  .table-lw17 { min-width: 17rem; max-width: 17rem; width: 17rem; text-align:left; }
  .table-lw18 { min-width: 18rem; max-width: 18rem; width: 18rem; text-align:left; }
  .table-lw19 { min-width: 19rem; max-width: 19rem; width: 19rem; text-align:left; }
  .table-rw1  { min-width:  1rem; max-width:  1rem; width:  1rem; text-align:right; }
  .table-rw2  { min-width:  2rem; max-width:  2rem; width:  2rem; text-align:right; }
  .table-rw3  { min-width:  3rem; max-width:  3rem; width:  3rem; text-align:right; }
  .table-rw4  { min-width:  4rem; max-width:  4rem; width:  4rem; text-align:right; }
  .table-rw5  { min-width:  5rem; max-width:  5rem; width:  5rem; text-align:right; }
  .table-rw6  { min-width:  6rem; max-width:  6rem; width:  6rem; text-align:right; }
  .table-rw7  { min-width:  7rem; max-width:  7rem; width:  7rem; text-align:right; }
  .table-rw8  { min-width:  8rem; max-width:  8rem; width:  8rem; text-align:right; }
  .table-rw9  { min-width:  9rem; max-width:  9rem; width:  9rem; text-align:right; }
  .table-rw10 { min-width: 10rem; max-width: 10rem; width: 10rem; text-align:right; }
  .table-rw11 { min-width: 11rem; max-width: 11rem; width: 11rem; text-align:right; }
  .table-rw12 { min-width: 12rem; max-width: 12rem; width: 12rem; text-align:right; }
  .table-rw13 { min-width: 13rem; max-width: 13rem; width: 13rem; text-align:right; }
  .table-rw14 { min-width: 14rem; max-width: 14rem; width: 14rem; text-align:right; }
  .table-rw15 { min-width: 15rem; max-width: 15rem; width: 15rem; text-align:right; }
  .table-rw16 { min-width: 16rem; max-width: 16rem; width: 16rem; text-align:right; }
  .table-rw17 { min-width: 17rem; max-width: 17rem; width: 17rem; text-align:right; }
  .table-rw18 { min-width: 18rem; max-width: 18rem; width: 18rem; text-align:right; }
  .table-rw19 { min-width: 19rem; max-width: 19rem; width: 19rem; text-align:right; }
  .table-cw1  { min-width:  1rem; max-width:  1rem; width:  1rem; text-align:center; }
  .table-cw2  { min-width:  2rem; max-width:  2rem; width:  2rem; text-align:center; }
  .table-cw3  { min-width:  3rem; max-width:  3rem; width:  3rem; text-align:center; }
  .table-cw4  { min-width:  4rem; max-width:  4rem; width:  4rem; text-align:center; }
  .table-cw5  { min-width:  5rem; max-width:  5rem; width:  5rem; text-align:center; }
  .table-cw6  { min-width:  6rem; max-width:  6rem; width:  6rem; text-align:center; }
  .table-cw7  { min-width:  7rem; max-width:  7rem; width:  7rem; text-align:center; }
  .table-cw8  { min-width:  8rem; max-width:  8rem; width:  8rem; text-align:center; }
  .table-cw9  { min-width:  9rem; max-width:  9rem; width:  9rem; text-align:center; }
  .table-cw10 { min-width: 10rem; max-width: 10rem; width: 10rem; text-align:center; }
  .table-cw11 { min-width: 11rem; max-width: 11rem; width: 11rem; text-align:center; }
  .table-cw12 { min-width: 12rem; max-width: 12rem; width: 12rem; text-align:center; }
  .table-cw13 { min-width: 13rem; max-width: 13rem; width: 13rem; text-align:center; }
  .table-cw14 { min-width: 14rem; max-width: 14rem; width: 14rem; text-align:center; }
  .table-cw15 { min-width: 15rem; max-width: 15rem; width: 15rem; text-align:center; }
  .table-cw16 { min-width: 16rem; max-width: 16rem; width: 16rem; text-align:center; }
  .table-cw17 { min-width: 17rem; max-width: 17rem; width: 17rem; text-align:center; }
  .table-cw18 { min-width: 18rem; max-width: 18rem; width: 18rem; text-align:center; }
  .table-cw19 { min-width: 19rem; max-width: 19rem; width: 19rem; text-align:center; }
  .textarea-margin {
    margin-left: 1rem;
    margin-right: 1rem;
  }
}
</style>
